import script from "./Consent.vue?vue&type=script&setup=true&lang=js"
export * from "./Consent.vue?vue&type=script&setup=true&lang=js"

import "./Consent.vue?vue&type=style&index=0&id=b91dfc3a&scoped=true&lang=css"

import exportComponent from "D:\\VSCODE_POJECT\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b91dfc3a"]])

export default __exports__